module.exports = __webpack_public_path__ + "static/img/bronze.c6caf73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/bronze.png
// module id = K2oe
// module chunks = 35